<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="formDadosCadastrais" v-model="formValidDadosCadastrais">
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-text-field
              id="txtDadosCadastraisTransportadora"
              v-model="dadosCadastrais.transportadora.cnpj"
              required
              :rules="
                formRulesComputed.transportadora.cnpj(
                  dadosCadastrais.transportadora.cnpj
                )
              "
              ref="txtDadosCadastraisTransportadora"
              mask="NN.NNN.NNN/NNNN-##"
              label="CNPJ*"
              browser-autocomplete="off"
              @blur="verificaCNPJ"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              id="txtDadosCadastraisRazaoSocial"
              ref="txtDadosCadastraisRazaoSocial"
              v-model="dadosCadastrais.transportadora.nome"
              required
              browser-autocomplete="off"
              :rules="
                formRulesComputed.transportadora.razaoSocial(
                  dadosCadastrais.transportadora.nome
                )
              "
              label="Razão Social*"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12 sm3>
                <v-autocomplete
                  label="País*"
                  id="txtDadosCadastraisPais"
                  ref="txtDadosCadastraisPaisRef"
                  :items="listaPaises"
                  item-text="nome"
                  item-value="nome"
                  no-data-text="País não encontrado"
                  browser-autocomplete="off"
                  v-model="dadosCadastrais.transportadora.enderecos[0].pais"
                  :rules="
                    formRulesComputed.endereco.pais(
                      dadosCadastrais.transportadora.enderecos[0].pais
                    )
                  "
                >
                </v-autocomplete>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm3>
                <v-autocomplete
                  label="UF*"
                  id="txtDadosCadastraisEstado"
                  ref="txtDadosCadastraisEstadoRef"
                  :items="listaEstados"
                  item-text="sigla"
                  item-value="sigla"
                  no-data-text="Estado não encontrado"
                  browser-autocomplete="off"
                  v-model="dadosCadastrais.transportadora.enderecos[0].estado"
                  :rules="
                    formRulesComputed.endereco.estado(
                      dadosCadastrais.transportadora.enderecos[0].estado
                    )
                  "
                  @blur="
                    carregaCidadesDoEstado(
                      dadosCadastrais.transportadora.enderecos[0].estado
                    )
                  "
                >
                </v-autocomplete>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm5>
                <v-autocomplete
                  label="Cidade*"
                  id="txtDadosCadastraisCidade"
                  ref="txtDadosCadastraisCidade"
                  :items="listaCidades"
                  item-text="nome"
                  item-value="nome"
                  no-data-text="Sem cidades para listar"
                  browser-autocomplete="off"
                  v-model="dadosCadastrais.transportadora.enderecos[0].cidade"
                  :rules="
                    formRulesComputed.endereco.cidade(
                      dadosCadastrais.transportadora.enderecos[0].cidade
                    )
                  "
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="dadosCadastrais.usuario.email"
              ref="usuarioEmail"
              id="txtDadosCadastraisEmail"
              required
              :rules="
                formRulesComputed.usuario.email(
                  dadosCadastrais.usuario.email,
                  emailEmUso
                )
              "
              :disabled="!getPermissao('salvarDadosUsuario')"
              label="E-mail*"
              browser-autocomplete="off"
              @blur="validaEmail()"
              validate-on-blur
            >
            </v-text-field>
          </v-flex>
          <v-flex v-if="!$vuetify.breakpoint.smAndDown"></v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="dadosCadastrais.usuario.nome"
              required
              id="txtDadosCadastraisNome"
              ref="txtDadosCadastraisNome"
              browser-autocomplete="off"
              :rules="
                formRulesComputed.usuario.nome(dadosCadastrais.usuario.nome)
              "
              label="Nome*"
              :disabled="!getPermissao('salvarDadosUsuario')"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 sm2>
            <v-text-field
              v-model="dadosCadastrais.usuario.ddd"
              id="txtDadosCadastraisDdd"
              ref="txtDadosCadastraisDdd"
              browser-autocomplete="off"
              :rules="
                formRulesComputed.telefone.ddd(
                  dadosCadastrais.usuario.ddd,
                  true
                )
              "
              :disabled="!getPermissao('salvarDadosUsuario')"
              maxlength="2"
              mask="##"
              :label="'DDD*'"
              required
            >
            </v-text-field>
          </v-flex>
          <v-flex xs8 sm4>
            <v-text-field
              v-model="dadosCadastrais.usuario.telefone"
              id="txtDadosCadastraisTelefone"
              ref="txtDadosCadastraisTelefone"
              browser-autocomplete="off"
              :rules="
                formRulesComputed.telefone.numero(
                  dadosCadastrais.usuario.telefone,
                  true
                )
              "
              :disabled="!getPermissao('salvarDadosUsuario')"
              :label="'Telefone*'"
              required
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-checkbox v-model="politicaPrivacidade" hide-details
              ><span slot="label" class="black--text"
                >Autorizo que meus dados coletados sejam utilizados para receber
                informações e ofertas de soluções do Grupo APISUL e compreendo
                que posso solicitar a retirada deste consentimento a qualquer
                momento. Caso queira saber mais, acesse a nossa
                <a
                  href="https://dpo.privacytools.com.br/policy-view/ZDMVYJzDq/1/política-de%C2%A0privacidade/pt_BR?s=1625162854301 "
                  >Política de Privacidade.</a
                ></span
              ></v-checkbox
            >
            <v-btn
              :disabled="!formValid"
              :block="$vuetify.breakpoint.xsOnly"
              color="primary white--text"
              :loading="loadingBtnDadosCadastrais"
              id="btnProximoDadosCadastrais"
              ref="btnProximoDadosCadastrais"
              @click.native="salvaDadosCadastrais"
            >
              Próximo
              <v-icon right class="hidden-sm-and-down">chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
      <v-dialog v-model="modalUsuarioCadastrado" max-width="500px" persistent>
        <v-card>
          <v-card-text>
            Já existe um usuário com este e-mail. Deseja ir para o login?
          </v-card-text>
          <v-card-actions>
            <v-btn
              flat
              @click.native="fecharModalUsuarioCadastrado"
              color="primary"
              >Fechar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn to="/Login" color="primary">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-snackbar
      :timeout="6000"
      :color="snackbar.sucesso ? 'success' : 'error'"
      multi-line
      v-model="snackbar.visivel"
    >
      {{ snackbar.mensagem }}
      <v-btn
        id="idFecharSnackbarBtn"
        dark
        flat
        @click.native="snackbar.visivel = false"
        >Fechar</v-btn
      >
    </v-snackbar>
  </v-layout>
</template>

<script>
import axios from "axios";
import formRules from "@/helpers/form-rules";
import perfil from "@/helpers/perfil";
import permissoes from "@/helpers/permissoes.js";
import questionarioFunctions from "@/components/pages/questionario/QuestionarioFunctions";
import usuarioHelper from "@/helpers/usuario-logado";
import validadores from "@/helpers/validadores";

export default {
  name: "dadoscadastrais",
  data: () => {
    return {
      politicaPrivacidade: false,
      transportadoraQuestionarioPai: null,
      usuarioQuestionarioPai: null,
      dataHoraInicio: "",
      tempoPreenchimentoTotal: "",
      formValidDadosCadastrais: false,
      loadingBtnDadosCadastrais: false,
      emailEmUso: false,
      countCarregamentosCidade: 0,
      listaPaises: [],
      listaEstados: [],
      listaCidades: [],
      dadosCadastrais: {
        usuarioNovo: false,
        transportadora: {
          id: 0,
          cnpj: "",
          nome: "",
          enderecos: [
            {
              cidade: "",
              estado: "",
              pais: "",
            },
          ],
        },
        usuario: {
          id: 0,
          email: "",
          nome: "",
          ddd: "",
          telefone: "",
        },
      },
      modalUsuarioCadastrado: false,
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: "",
      },
    };
  },
  computed: {
    elementoPai: function () {
      return this.$parent.$parent.$parent;
    },
    formRulesComputed: function () {
      return formRules;
    },
    formValid: function(){
      const self = this;
      if(self.formValidDadosCadastrais==true && self.politicaPrivacidade == true){
        return true;
      }else{
        return false;
      }
    }
  },
  mounted: async function () {
    this.resetDataHoraInicio();
    if (usuarioHelper.USUARIO_LOGADO()) {
      if (usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.CLIENTE) {
        this.dadosCadastrais.usuario.email =
          usuarioHelper.USUARIO_LOGADO().email;
        this.buscaUsuario();
      }
    }
    await this.carregaPaises();
    await this.carregaEstados();
  },
  methods: {
    getPermissao: function (requested, param) {
      const permissionObj = permissoes;
      if (param) {
        return eval(
          "permissionObj." +
            this.$route.name +
            "." +
            requested +
            "(" +
            param +
            ")"
        );
      } else {
        return eval("permissionObj." + this.$route.name + "." + requested);
      }
    },
    usarQuestionarioPai: async function (transportadoraParam, usuarioParam) {
      //O código comentado é a preparação para receber dados de usuário na clonagem
      const self = this;
      await self.carregaEstados();

      self.transportadoraQuestionarioPai = transportadoraParam;
      self.usuarioQuestionarioPai = usuarioParam;

      self.dadosCadastrais.transportadora.id = transportadoraParam.id;
      self.dadosCadastrais.transportadora.cnpj = transportadoraParam.cnpj;
      self.dadosCadastrais.transportadora.nome = transportadoraParam.nome;
      self.dadosCadastrais.transportadora.enderecos =
        transportadoraParam.enderecos;

      self.dadosCadastrais.usuario.id = usuarioParam.id;
      self.dadosCadastrais.usuario.email = usuarioParam.email;
      self.dadosCadastrais.usuario.nome = usuarioParam.nome;
      self.dadosCadastrais.usuario.ddd =
        usuarioParam.telefones[0].ddd != 0
          ? `${usuarioParam.telefones[0].ddd}`
          : "";
      self.dadosCadastrais.usuario.telefone =
        usuarioParam.telefones[0].telefone;
    },
    resetDataHoraInicio: function () {
      this.dataHoraInicio = new Date();
    },
    somaTempoPreenchimentoTotal: function () {
      const self = this;
      var dateTimeNow = new Date();
      if (self.tempoPreenchimentoTotal == "") {
        self.tempoPreenchimentoTotal = parseInt(
          dateTimeNow.getTime() / 1000 / 60 -
            self.dataHoraInicio.getTime() / 1000 / 60
        );
      } else {
        self.tempoPreenchimentoTotal += parseInt(
          dateTimeNow.getTime() / 1000 / 60 -
            self.dataHoraInicio.getTime() / 1000 / 60
        );
      }
    },
    carregaPaises: async function () {
      const self = this;
      await axios
        .get(`${process.env.URL_GEOMS}/v1/no-auth/buscaTodosPaises`)
        .then((response) => {
          self.listaPaises = response.data;
        });
    },
    carregaEstados: async function () {
      const self = this;
      await axios
        .get(`${process.env.URL_GEOMS}/v1/no-auth/buscaTodosEstadosSemDiversos`)
        .then((response) => {
          self.listaEstados = response.data;
        })
        .catch((error) => {
          self.snackbarSalvarTransportadora.mensagem =
            error.response.data.message;
          self.snackbarSalvarTransportadora.sucesso = false;
          self.snackbarSalvarTransportadora.visivel = true;
          self.loadingSalvar = false;
        });
    },
    carregaCidadesDoEstado: function (estadoParam) {
      const self = this;
      if (estadoParam && estadoParam != "") {
        if (
          self.dadosCadastrais.transportadora.enderecos[0].cidade != "" &&
          self.countCarregamentosCidade > 1
        ) {
          self.dadosCadastrais.transportadora.enderecos[0].cidade = "";
        }
        const estadoSelecionado = self.listaEstados.find((estado) => {
          return estado.sigla == estadoParam;
        });
        axios
          .get(
            `${process.env.URL_GEOMS}/v1/no-auth/buscaCidadesDeUmEstado?idestado=${estadoSelecionado.id}`
          )
          .then((response) => {
            self.listaCidades = response.data;
            self.countCarregamentosCidade++;
          })
          .catch((error) => {
            self.snackbarSalvarTransportadora.mensagem =
              error.response.data.message;
            self.snackbarSalvarTransportadora.sucesso = false;
            self.snackbarSalvarTransportadora.visivel = true;
            self.loadingSalvar = false;
          });
      }
    },
    verificaCNPJ: function () {
      const self = this;
      self.countCarregamentosCidade = 0;
      if (
        validadores.validarCNPJ(self.dadosCadastrais.transportadora.cnpj.trim())
      ) {
        axios
          .get(
            `${process.env.URL_TRANSPORTADORAMS}/v1/no-auth/buscaPorCnpj?cnpj=${self.dadosCadastrais.transportadora.cnpj}`
          )
          .then((response) => {
            if (
              response.data != "" &&
              response.data != null &&
              response.data != undefined
            ) {
              const transportadoraRecebida = response.data;
              if (transportadoraRecebida.enderecos.length > 0) {
                self.dadosCadastrais.transportadora = transportadoraRecebida;
                self.countCarregamentosCidade++;
                self.carregaCidadesDoEstado(
                  self.dadosCadastrais.transportadora.enderecos[0].estado
                );
              } else {
                self.dadosCadastrais.transportadora.id =
                  transportadoraRecebida.id;
                self.dadosCadastrais.transportadora.cnpj =
                  transportadoraRecebida.cnpj;
                self.dadosCadastrais.transportadora.nome =
                  transportadoraRecebida.nome;
              }
              self.carregarQar(self.dadosCadastrais.transportadora);
            } else {
              self.resetDadosTransportadora(
                self.dadosCadastrais.transportadora.cnpj
              );
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    carregarQar: async function (transportadora) {
      const self = this;
      if (questionarioFunctions.podeCarregarQar()) {
        axios
          .get(
            `${process.env.URL_QAR}/v1/qar-transportadora/${transportadora.id}`,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
              },
            }
          )
          .then((response) => {
            const qar = response.data;
            if (qar) {
              self.elementoPai.$refs.dadosoperacionais.usarQuestionarioPai(
                qar.dadosOperacionais
              );
              self.elementoPai.$refs.segurosanteriores.usarQuestionarioPai(
                qar.segurosAnteriores
              );
              self.carregarUsuarioSolicitanteQar(qar.idUsuarioSolicitante);
            }
          });
      }
    },
    carregarUsuarioSolicitanteQar: function (idUsuario) {
      const self = this;
      if (questionarioFunctions.podeCarregarQar()) {
        axios
          .get(
            `${process.env.URL_USUARIOMS}/v1/buscaUsuarioSimplesPorId?id=${idUsuario}`,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
              },
            }
          )
          .then((response) => {
            const usuario = response.data;
            if (usuario) {
              self.dadosCadastrais.usuario.id = usuario.id;
              self.dadosCadastrais.usuario.email = usuario.email;
              self.dadosCadastrais.usuario.nome = usuario.nome;
              self.dadosCadastrais.usuario.ddd =
                usuario.telefones[0].ddd != 0
                  ? `${usuario.telefones[0].ddd}`
                  : "";
              self.dadosCadastrais.usuario.telefone =
                usuario.telefones[0].telefone;
            } else {
              self.resetDadosUsuario();
            }
          });
      }
    },
    validaEmail: function () {
      const self = this;
      axios
        .get(
          `${process.env.URL_USUARIOMS}/v1/no-auth/verificaEmailCadastrado?email=${self.dadosCadastrais.usuario.email}`
        )
        .then((response) => {
          self.emailEmUso = response.data;

          if (self.emailEmUso && usuarioHelper.USUARIO_LOGADO()) {
            self.buscaUsuario();
          } else if (self.emailEmUso) {
            self.verificaUsuario();
          }
        })
        .catch((erro) => {
          self.$store.commit("endLoading");
          self.snackbar.visivel = true;
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = "Ocorreu um erro ao validar o e-mail";
        });
    },
    buscaUsuario: function () {
      const self = this;
      if (
        !self.$refs.usuarioEmail.error ||
        usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.COMERCIAL
      ) {
        axios
          .get(
            `${process.env.URL_USUARIOMS}/v1/buscaUsuarioPorEmail?email=${
              self.dadosCadastrais.usuario.email
            }&token=${usuarioHelper.USUARIO_LOGADO().token}`,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
              },
            }
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              self.dadosCadastrais.usuario.id = data.id;
              self.dadosCadastrais.usuario.nome = data.nome;
              self.dadosCadastrais.usuario.ddd =
                data.telefones[0].ddd != 0 ? `${data.telefones[0].ddd}` : "";
              self.dadosCadastrais.usuario.telefone =
                data.telefones[0].telefone;
              self.emailEmUso = false;
            }
          })
          .catch((erro) => {
            self.emailEmUso = true;
            self.snackbar.mensagem = erro.response.data.message;
            self.snackbar.sucesso = false;
            self.snackbar.visivel = true;
          });
      }
    },
    salvaDadosTransportadora: function () {
      const self = this;
        return axios.post(
          `${process.env.URL_TRANSPORTADORAMS}/v1/no-auth/insereOuAtualizaPorCnpjViaQuestionario`,
          {
            cnpj: self.dadosCadastrais.transportadora.cnpj,
            nome: self.dadosCadastrais.transportadora.nome,
            enderecos: self.dadosCadastrais.transportadora.enderecos,
            tipoCliente: self.elementoPai.tipoCliente.valor,
          }
        );

    },
    verificaUsuario: function () {
      const self = this;
      axios
        .get(
          `${process.env.URL_USUARIOMS}/v1/no-auth/verificaUsuarioCadastrado?email=${self.dadosCadastrais.usuario.email}`
        )
        .then((response) => {
          if (response.data) {
            self.modalUsuarioCadastrado = true;
          } else {
            self.emailEmUso = false;
          }
        });
    },
    salvaDadosUsuario: function () {
      const self = this;
      if (self.getPermissao("salvarDadosUsuario")) {
        return axios.post(
          `${process.env.URL_USUARIOMS}/v1/no-auth/insereOuAtualizaCliente`,
          {
            email: self.dadosCadastrais.usuario.email,
            nome: self.dadosCadastrais.usuario.nome,
            ativo: true,
            telefones: [
              {
                ddd: self.dadosCadastrais.usuario.ddd,
                telefone: self.dadosCadastrais.usuario.telefone,
              },
            ],
            perfil: null,
          }
        );
      }
    },
    fecharModalUsuarioCadastrado: function () {
      this.dadosCadastrais.usuario.email = "";
      this.modalUsuarioCadastrado = false;
    },
    salvaDadosCadastrais: function () {
      const self = this;
      self.loadingBtnDadosCadastrais = true;
      if (self.$refs.formDadosCadastrais.validate()) {
        axios
          .all([self.salvaDadosTransportadora(), self.salvaDadosUsuario()])
          .then(
            axios.spread(function (resTrans, resUsu) {
              const dataTrans = resTrans.data;
              self.dadosCadastrais.transportadora.id = dataTrans.id;

              if (resUsu) {
                const dataUsu = resUsu.data;
                self.dadosCadastrais.usuario.id = dataUsu.id;
                if (!usuarioHelper.USUARIO_LOGADO()) {
                  self.dadosCadastrais.usuarioNovo = true;
                }
              }
              if (
                self.dadosCadastrais.transportadora.id > 0 &&
                self.dadosCadastrais.usuario.id > 0
              )
                self.elementoPai.proximoPasso();
            })
          )
          .catch((err) => {
            console.log(err);
          })
          .then(() => {
            self.loadingBtnDadosCadastrais = false;
          });
      }
    },
    montaModelo: function () {
      const self = this;
      return {
        idTransportadora: self.dadosCadastrais.transportadora.id,
        usuarioSolicitante: self.dadosCadastrais.usuario,
        usuarioNovo: self.dadosCadastrais.usuarioNovo,
      };
    },
    resetDadosUsuario: function (email) {
      this.dadosCadastrais.usuario = {
        id: 0,
        email: email ? email : "",
        nome: "",
        ddd: "",
        telefone: "",
      };
    },
    resetDadosTransportadora: function (cnpj) {
      this.dadosCadastrais.transportadora = {
        id: 0,
        cnpj: cnpj,
        nome: "",
        enderecos: [
          {
            cidade: "",
            estado: "",
            pais: "",
          },
        ],
      };
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/pages/questionario/DadosCadastraisQ.vue